<template>
  <div
    v-if="!loading"
    class="list"
  >
    <div v-if="mList && mList.length">
      <load-more
        class="wrapper"
        :data="mList"
        :page="pagination.currentPage"
        :total="pagination.total"
        :limit="pagination.pageSize"
        @loadData="getAuditList"
      >
        <template>
          <ul class="content">
            <li
              v-for="(item, index) in mList"
              :key="index"
            >
              <my-item
                :data="item"
                :index="index"
                :type-param="typeParam"
                @handleDetail="handlerDetail"
              />
            </li>
          </ul>
          <div class="loading-wrapper" />
        </template>
      </load-more>
    </div>
    <div
      v-else
      class="blank"
    >
      <img
        src="@/assets/images/blank.png"
        :alt="altTip"
      >
      <div class="text">
        {{ $t('message["1553"]') }}
      </div>
    </div>
  </div>
  <cube-loading
    v-else
    :size="24"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import LoadMore from '@/components/mobile/LoadMore.vue'
import Item from './Item.vue'
import { getEncode } from '@/lib/mix'
import { setCodeData } from '@/lib/utils'

export default {
  components: {
    LoadMore,
    MyItem: Item
  },
  props: {
    from: {
      type: String,
      default: ''
    },
    typeParam: {
      type: [String, Number],
      default: ''
    },
    keywords: {
      type: Object,
      default: () => { }
    },
    keywordsStr: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('inquery/auditData', [
      'loading',
      'titles',
      'list',
      'pagination'
    ]),
    mList () {
      let data = _.cloneDeep(this.list)
      for (let item of data) {
        for (let fieldkey in item) {
          let column = item[fieldkey]
          item.list = item.list || {}

          if (fieldkey === 'code' || fieldkey === 'inquiryid') continue
          let obj = {}
          if (_.isPlainObject(column)) {
            obj = item[fieldkey]
          } else if (_.isString(column)) {
            obj.fieldvalue = column || ''
          }
          obj.fieldkey = fieldkey
          for (let k in this.titles) {
            if (k === fieldkey) {
              obj.title = this.titles[k].fieldname
              item.list[fieldkey] = obj
            }
          }
        }
      }
      return data
    },
    pid () {
      return this.$route.params.pid
    },
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    },
    altTip () {
      return this.$t('message["1553"]')
    }
  },
  watch: {
    /* typeParam (val) {
      // this.pagination.currentPage = 1
      // this.pagination.pageSize = 10
      // this.getAuditList()
      this.$router.push({
        name: 'InqueryAudit',
        query: {
          ...this.$route.query,
          keywords: '',
          page: 1,
          limit: 10
        }
      })
    }, */
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize

      this.getAuditList()
    }
  },
  created () {
    this.getAuditList()
  },
  methods: {
    ...mapActions('inquery/auditData', ['fetchList']),
    async getAuditList () {
      let newKeys = Object.assign({}, this.keywords)
      if (this.keywordsStr) {
        let enCode = await getEncode()
        if (!/^L?\d+$/.test(newKeys.keyword1)) {
          newKeys.keyword1 = await setCodeData(newKeys.keyword1, enCode)
        }
        newKeys.keyword2 = await setCodeData(newKeys.keyword2, enCode)
        newKeys.keyword3 = await setCodeData(newKeys.keyword3, enCode)
      }
      console.log(newKeys)
      const chain = await this.fetchList()
      chain
        .params({
          ...newKeys,
          type: this.typeParam,
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize
        })
        .onSuccess(res => {
          document.title = this.$t('message["1048"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
        })
        .fetch()
    },

    handlerDetail (data) {
      this.$router.push({
        path: `/project/${this.pid}/inquery/detail/${data.inquiryid}`,
        query: {
          ...this.$route.query,
          from: 'audit'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  // padding: 10px 0 0;
  .cube-scroll-wrapper {
    height: calc(100vh - 94px);
    overflow: hidden;
  }
  .cube-btn {
    width: 200px;
    margin: 10px auto;
  }
}
</style>
